export const WHATSAPP_PRICING_URL =
  'https://help.manychat.com/hc/articles/14281380243740-WhatsApp-Pricing-Quick-Guide'
export const WHATSAPP_CALCULATOR_URL = 'https://calculator.manychat.com/'
